<template>
  <table ref="tabela" :class="internalTableClass" class="floatThead">
    <slot></slot>
  </table>
</template>

<script>
  import $ from 'jquery'
  import 'floatthead'

  export default {
    name: 'float-thead',
    props: {
      tableClass:{type:String, default: 'floatThead'},
      // id:{type:String, default:'floatTheadTable'},
      position: { type: String, default: 'auto' },
      top: { type: [Number, Function], default: 64 },
      zIndex: { type: Number, default: 50 },
      /*scrollContainer: { type: [Boolean, Function], default: () => { } },
      responsiveContainer: { type: Function },
      headerCellSelector: { type: String, default: 'tr:first>th:visible' },
      floatTableClass: { type: String, default: 'floatThead-table' },
      floatContainerClass: { type: String, default: 'floatThead-container' },
      bottom: { type: [Number, Function], default: 0 },
      debug: { type: Boolean, default: false },
      getSizingRow: { type: Function },
      copyTableClass: { type: Boolean, default: true },
      autoReflow: { type: Boolean, default: false }*/
    },
    data () {
      return {
        table: undefined
      }
    },
    computed: {
      internalTableClass: function() {
        return `${this.tableClass} tituloBold`;
      }
    },
    methods: {
      destroy () {
        return this.table.floatThead('destroy')
      },
      reflow () {
        return this.table.floatThead('reflow')
      },
      getRowGroups () {
        return this.table.floatThead('getRowGroups')
      },
      resizeDiv() {
        const div = document.querySelector('.floatThead').parentElement.nextElementSibling;

        const observer = new MutationObserver(() => {
          const larguraAtual = div.offsetWidth;
          if (larguraAtual !== div.offsetWidthAnterior) {
            div.offsetWidthAnterior = larguraAtual;
            this.reflow();
          }
        });

        observer.observe(div, {
          attributes: true,
          childList: true,
          subtree: true
        });
      }
    },
    mounted () {      
      this.table = $(this.$refs.tabela);
      let options = {
        position: this.position,
        top: this.top,
        zIndex: this.zIndex,

        /*scrollContainer: this.scrollContainer,
        responsiveContainer: this.responsiveContainer,
        headerCellSelector: this.headerCellSelector,
        floatTableClass: this.floatTableClass,
        floatContainerClass: this.floatContainerClass,
        bottom: this.bottom,
        debug: this.debug,
        getSizingRow: this.getSizingRow,
        copyTableClass: this.copyTableClass,
        autoReflow: this.autoReflow*/
      }

      this.table.floatThead(options)

      this.table.on('floatThead', (e, isFloated, $floatContainer) =>
        this.$emit('floatThead', e, isFloated, $floatContainer)
      )
      this.table.on('reflowed', (e, $floatContainer) =>
        this.$emit('reflowed', e, $floatContainer)
      )

      this.resizeDiv();
    },
    updated() {
      this.reflow();
    }
  }
</script>
<style scoped>
  .tituloBold > thead > tr > td {
    font-weight: 500;
  }

  .floatThead, .floatThead-container {
    table-layout: auto !important;
    min-width: 100% !important;
    max-width: 100% !important;
    width: 100% !important;
  }
</style>


// WEBPACK FOOTER //
// FloatThead.vue?9aa9cd0a